// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_o4-5";
export var filledCircle = "_o4-4";
export var historyEntry = "_o4-3";
export var messageSideLeft = "_o4-1";
export var messageSideRight = "_o4-2";
export var orderTrackingCarouselWrapper = "_o4-6";
export var orderTrackingInfoContainer = "_o4-0";